import { render, staticRenderFns } from "./BasicCollectionPage.vue?vue&type=template&id=4a139682&scoped=true"
import script from "./BasicCollectionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicCollectionPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BasicCollectionPage.vue?vue&type=style&index=0&id=4a139682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a139682",
  null
  
)

export default component.exports